// src/hooks/useSortedItems.js

import { useMemo } from "react";

/**
 * 商品のソートロジック
 * 各カテゴリ内で、`item_badge`が`New`のアイテムが最も優先される。
 * もし、複数の`New`を持つアイテムがある場合は、`id`に基づいて並び順が決定される。
 * 考慮される要素： `item_badge`、`id`、`item_category`
 */
const useSortedItems = (items) => {
 return useMemo(() => {
  return [...items].sort((a, b) => {
   if (a.item_category === b.item_category) {
    if (a.item_badge === "New" && b.item_badge !== "New") return -1;
    if (a.item_badge !== "New" && b.item_badge === "New") return 1;
    return a.id - b.id;
   }
   return 0;
  });
 }, [items]);
};

// /**
//  * 商品のソートロジック
//  * 各シリーズ内で、`item_badge`が`New`のアイテムが最も優先される。
//  * もし、複数の`New`を持つアイテムがある場合は、`id`に基づいて並び順が決定される。
//  * 考慮される要素： `item_badge`、`id`、`item_series`
//  */
// const useSortedItems = (items) => {
//  return useMemo(() => {
//   return [...items].sort((a, b) => {
//    if (a.item_series === b.item_series) {
//     if (a.item_badge === "New" && b.item_badge !== "New") return -1;
//     if (a.item_badge !== "New" && b.item_badge === "New") return 1;
//     return a.id - b.id;
//    }
//    return 0;
//   });
//  }, [items]);
// };

// /**
//  * 商品のソートロジック
//  * 商品リストより、`item_badge`の`New`を持つ商品は商品リストの並び順で最も優先される。
//  * もし、複数の商品が`New`を持つ場合は`id`と組み合わせて、並び順が決定される。
//  * 考慮される要素： `item_badge`、`id`
//  */
// const useSortedItems = (items) => {
//  return useMemo(() => {
//   return [...items].sort((a, b) => {
//    if (a.item_badge === "New" && b.item_badge !== "New") return -1;
//    if (a.item_badge !== "New" && b.item_badge === "New") return 1;
//    return a.id - b.id;
//   });
//  }, [items]);
// };

export default useSortedItems;
